<!-- section start -->

<div>
    <section class="section_one">
        <div class="container">
            <div class="row">
                <div class="col-md-12">

                    <div class="ibox">
                        <div class="ibox-content">
                            <mat-card>
                                <ng-container *ngIf="dataAvailable; else noData">
                                    <!--- no data-->
                                    <div class="searchpaginator">
                                        <div class="table_search">
                                            <input type="text" class="form-control" (keyup)="applyFilter($event)"
                                                placeholder="Search">
                                        </div>
                                        <div>
                                            <mat-paginator [pageSize]="10"
                                                [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <mat-card-content>
                                            <table mat-table [dataSource]="recepitcancalltion" matSort class="table_resize">
                                                <ng-container matColumnDef="campusName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns>Payment Campus Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}"
                                                        style="text-align: left;">
                                                        {{row.campusName}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="userName">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> User Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.userName}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="daysheetDate">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> Day Sheet Date </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <span class="working_txt">{{row.daysheetDate | date: 'dd/MM/yyyy ' }}</span>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="admNo">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        class="resizer" appResizableColumns>Adm No
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.admNo}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="prePrintedReceiptNo">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> Pre Printed ReceiptNo</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.prePrintedReceiptNo}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="payMode">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> PayMode</th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}"
                                                        style="text-align: left;">
                                                        {{row.payMode}} </td>
                                                </ng-container>

                                                <ng-container matColumnDef="amount">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                        appResizableColumns> Amount
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        {{row.amount 
                                                         | million }} </td>
                                                </ng-container>
                                                
                                               
                                                
                                                <ng-container matColumnDef="view">
                                                    <th mat-header-cell *matHeaderCellDef> View </th>
                                                    <td mat-cell *matCellDef="let row"
                                                        [ngClass]="{'highlighted': isSelected(row)}">
                                                        <button (click)="alldata(row)"
                                                            class="view_details">View</button>
                                                    </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef="displayedColumns2  sticky: true">
                                                </tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                                                <!-- Row shown when there is no matching data. -->
                                                <tr class="mat-row" *matNoDataRow>
                                                    <td class="mat-cell" class="not_matchdata" colspan="11">No data matching the filter
                                                        </td>
                                                </tr>
                                            </table>
                                        </mat-card-content>
                                    </div>
                                </ng-container>
                            </mat-card>
                            <ng-template #noData>
                                <section class="section_one">
                                    <div class="cctvcouncelling__sec">
                                        <div class="councellist__flex">
                                            <div>
                                                <div class="nodata_center">
                                                    <figure class="mb-0">
                                                        <img src="../../../../assets/image/nodata.png" alt="nodata"
                                                            class="nodata">
                                                    </figure>
                                                    <p class="no_data">No Data Found</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </ng-template>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>


<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

